// 和对应的工作交流h5工程共享数据（防止再次走免登录逻辑）
// const PROJECT = process.env.PROJECT_DATA.PROJECT_NAME||'';
const PROJECT = 'ai-report'

/* 缓存规则是使用'工程名-'组合
	localStorage
 */
export function setLocalStorage(key, value) {
  return localStorage.setItem(PROJECT + '-' + key, JSON.stringify(value));
}

export function getLocalStorage(key) {
  let json = localStorage.getItem(PROJECT + '-' + key);
  if (!json || json === 'undefined') {
    return '';
  }
  return JSON.parse(json);
}

export function removeLocalStorage(key) {
  return localStorage.removeItem(PROJECT + '-' + key);
}

/*
	sessionStorage
 */
export function setSessionStorage(key, value) {
  return sessionStorage.setItem(PROJECT + '-' + key, JSON.stringify(value));
}

export function getSessionStorage(key) {
  let json = sessionStorage.getItem(PROJECT + '-' + key);
  if (!json || json === 'undefined') {
    return '';
  }
  return JSON.parse(json);
}

export function removeSessionStorage(key) {
  return sessionStorage.removeItem(PROJECT + '-' + key);
}

/*
	cookie
 */
export function setCookie(name, value, day) {
  const date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + '=' + value + ';expires=' + date;
}

export function getCookie(name) {
  const arr = document.cookie.split('; ');
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split('=');
    if (arr2[0] === name) {
      return arr2[1];
    }
  }
  return '';
}

export function removeCookie(name) {
  setCookie(name, '1', -1);
}


  // 时间格式化函数（value：时间戳，format：格式）
export function dateFormat(value, format = 'yyyy-MM-dd HH:mm:ss') {
    if (!value || value == '' || value == 0) {
      return '';
    }
    value = isNaN(+value) ? value : +value;
    value = new Date(value);
    let o = {
      'M+': value.getMonth() + 1,
      'd+': value.getDate(),
      'h+': value.getHours() % 12 == 0 ? 12 : value.getHours() % 12,
      'H+': value.getHours(),
      'm+': value.getMinutes(),
      's+': value.getSeconds(),
      'q+': Math.floor((value.getMonth() + 3) / 3),
      S: value.getMilliseconds()
    };
  
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (value.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
  
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }
  
    return format;
  }
/**
 * 判断设备
 * @param {*} options
 */
export function getDevice() {
  var agent = navigator.userAgent.toLowerCase();
  var device = {};
  if (agent.includes('micromessenger')) {
    device.app = 'weixin'; // 在微信中打开
  } else if (agent.match(/QQ\//i) === 'qq/') {
    device.app = 'qq'; // 在QQ打开
  } else if (agent.match(/WeiBo/i) === 'weibo') {
    device.app = 'weibo'; // 在新浪微博客户端打开
  } else if (agent.includes('dingtalk')) {
    device.app = 'dingtalk'; // 在钉钉打开
  }

  if (agent.indexOf('android') !== -1) {
    device.platform = 'Android';
  } else if (agent.indexOf('iphone') !== -1) {
    device.platform = 'iOS';
  }

  device.isPad = agent.indexOf('ipad') !== -1 || agent.indexOf('pad') !== -1;
  return device;
}